module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Click here for modal")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("What was sent :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentMessage))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Iview UI Framework")]), _vm._v(" "), _c('p', [_vm._v("Iview is a UI Framework based on Vue with "), _c('a', {
    attrs: {
      "href": "https://github.com/iview/iview"
    }
  }, [_vm._v(" 5k stars")]), _vm._v(" on Github")]), _vm._v(" "), _c('p', [_vm._v("It "), _c('a', {
    attrs: {
      "href": "https://github.com/iview/iview/search?utf8=%E2%9C%93&q=v-html&type="
    }
  }, [_vm._v("currently")]), _vm._v(" implements multiple time the v-html tag where it can possibly be user filled fields")]), _vm._v(" "), _c('p', [_vm._v("The component on the left is Iview's "), _c('strong', [_vm._v("Confim Modal")]), _vm._v(" component. Here we hijack the "), _c('strong', [_vm._v("Content")]), _vm._v(" field.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e486f4"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/iview.vue
// module id = 126
// module chunks = 1